import { render, staticRenderFns } from "./AddFeedTankModal.vue?vue&type=template&id=3f52c317&"
import script from "./AddFeedTankModal.vue?vue&type=script&lang=ts&"
export * from "./AddFeedTankModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports